import { render, staticRenderFns } from "./match-group.vue?vue&type=template&id=181b7671"
import script from "./match-group.vue?vue&type=script&lang=js"
export * from "./match-group.vue?vue&type=script&lang=js"
import style0 from "./match-group.vue?vue&type=style&index=0&id=181b7671&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports